import { Box } from "@mui/material";
import React from "react";
import { CircleProgress } from "../../CircleProgress/circle.progress";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

interface IActiveBonusInfoProps {
  id: number;
  type: string;
  bonus_user_fs_type: {
    bonus_amount: string | null;
    status: string;
    wagered: string;
    wager: string;
  } | null;
  bonus_user_pers_type: {
    bonus_amount: string | null;
    status: string;
    wagered: string;
    wager: string;
  } | null;
  days_left: number;
  min_dep: string;
  game: string | undefined;
  cancelBonus?: (bonus_id: number) => void;
}

export const ActiveBonusInfo = ({
  id,
  type,
  bonus_user_fs_type,
  bonus_user_pers_type,
  days_left,
  min_dep,
  game,
  cancelBonus,
}: IActiveBonusInfoProps) => {
  const { t, i18n } = useTranslation();
  return (
    <Box className="my_activated_bonus__info__container">
      <Box className="my_activated_bonus__info__bonus-type">
        <span>{t("main.bonuses.type_label")} </span>
        {type === "cashback"
          ? t("main.bonuses.types.cashback")
          : bonus_user_fs_type && bonus_user_pers_type
          ? t("main.bonuses.types.fs_pers")
          : bonus_user_fs_type
          ? t("main.bonuses.types.fs")
          : t("main.bonuses.types.pers")}
      </Box>
      <Box className="my_activated_bonus__info__bonus-status">
        <span>{t("main.bonuses.bonus_status.label")} </span>
        {bonus_user_fs_type && bonus_user_pers_type
          ? bonus_user_pers_type.status === "active"
            ? t("main.bonuses.bonus_status.waiting_deposit", { min_dep })
            : bonus_user_pers_type.status === "wagering" ||
              bonus_user_pers_type.status === "deposit" ||
              bonus_user_fs_type.status === "wagering" ||
              bonus_user_fs_type.status === "deposit"
            ? t("main.bonuses.bonus_status.wagering")
            : t("bonus_status.completed")
          : bonus_user_pers_type
          ? bonus_user_pers_type.status === "active"
            ? t("main.bonuses.bonus_status.waiting_deposit", { min_dep })
            : bonus_user_pers_type.status === "wagering" ||
              bonus_user_pers_type.status === "deposit"
            ? t("main.bonuses.bonus_status.wagering")
            : t("main.bonuses.bonus_status.completed")
          : bonus_user_fs_type
          ? bonus_user_fs_type.status === "active"
            ? t("main.bonuses.bonus_status.waiting_deposit", { min_dep })
            : bonus_user_fs_type.status === "wagering" ||
              bonus_user_fs_type.status === "deposit"
            ? t("main.bonuses.bonus_status.wagering")
            : t("main.bonuses.bonus_status.completed")
          : null}
      </Box>
      <Box className="my_activated_bonus__info__bonus-time">
        <span>{t("main.bonuses.bonus_status.title")} </span>
        {days_left < 0
          ? t("main.bonuses.bonus_status.completed")
          : days_left === 0
          ? t("main.bonuses.bonus_status.last_day")
          : days_left === 1
          ? t("main.bonuses.bonus_status.days_left.one", { count: days_left })
          : days_left === 2 || days_left === 3 || days_left === 4
          ? t("main.bonuses.bonus_status.days_left.few", { count: days_left })
          : t("main.bonuses.bonus_status.days_left.many", { count: days_left })}
      </Box>
      <Box className="my_activated_bonus__info__bonus-wager">
        {bonus_user_pers_type && bonus_user_fs_type ? (
          <>
            <Box className="my_activated_bonus__info__bonus">
              <Box className="my_activated_bonus__info__bonus-title">
                {t("main.bonuses.fs_wager_title")}
              </Box>
              <CircleProgress
                percents={
                  Math.floor(
                    (+bonus_user_fs_type.wagered / +bonus_user_fs_type.wager) *
                      100
                  ) || 0
                }
              />
              <Box className="my_activated_bonus__info__bonus-description">
                <span>{t("main.bonuses.wager_left")} </span>{" "}
                {+bonus_user_fs_type.wager - +bonus_user_fs_type.wagered}
                <Box sx={{ textAlign: "center" }}>
                  {bonus_user_fs_type.status === "deposit" && game && (
                    <Link to={`/slots/${game}.game`}>
                      {t("main.bonuses.go_to_game")}
                    </Link>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className="my_activated_bonus__info__bonus">
              <Box className="my_activated_bonus__info__bonus-title">
                {t("main.bonuses.dep_bonus_wager_title")}
              </Box>
              <CircleProgress
                percents={
                  Math.floor(
                    (+bonus_user_pers_type.wagered /
                      +bonus_user_pers_type.wager) *
                      100
                  ) || 0
                }
              />
              <Box className="my_activated_bonus__info__bonus-description">
                <span>{t("main.bonuses.wager_left")} </span>{" "}
                {+bonus_user_pers_type.wager - +bonus_user_pers_type.wagered}
              </Box>
            </Box>
          </>
        ) : bonus_user_pers_type ? (
          <Box className="my_activated_bonus__info__bonus">
            <Box className="my_activated_bonus__info__bonus-title">
              {t("main.bonuses.dep_bonus_wager_title")}
            </Box>
            <CircleProgress
              percents={
                Math.floor(
                  (+bonus_user_pers_type.wagered /
                    +bonus_user_pers_type.wager) *
                    100
                ) || 0
              }
            />
            <Box className="my_activated_bonus__info__bonus-description">
              <span>{t("main.bonuses.wager_left")} </span>{" "}
              {+bonus_user_pers_type.wager - +bonus_user_pers_type.wagered}
            </Box>
          </Box>
        ) : (
          <Box className="my_activated_bonus__info__bonus">
            <Box className="my_activated_bonus__info__bonus-title">
              {t("main.bonuses.fs_wager_title")}
            </Box>
            <CircleProgress
              percents={
                Math.floor(
                  //@ts-ignore
                  (+bonus_user_fs_type.wagered / +bonus_user_fs_type.wager) *
                    100
                ) || 0
              }
            />
            <Box className="my_activated_bonus__info__bonus-description">
              <span>{t("main.bonuses.wager_left")} </span>{" "}
              {
                //@ts-ignore
                +bonus_user_fs_type.wager - +bonus_user_fs_type.wagered
              }
              {
                //@ts-ignore
                bonus_user_fs_type.status === "deposit" && game && (
                  <Link to={`/slots/${game}.game`}>
                    {t("main.bonuses.go_to_game")}
                  </Link>
                )
              }
            </Box>
          </Box>
        )}
      </Box>
      {cancelBonus && (
        <Box
          className="my_activated_bonus__info__bonus-delete"
          onClick={() => {
            cancelBonus(id);
          }}
        >
          <DeleteIcon />
        </Box>
      )}
    </Box>
  );
};
